import { getShoppingCart, updateShoppingCart, getProfile } from './middleware-api.js';

function hasAffiliateCartParam() {
  const params = new URLSearchParams(window.location.search);
  return params.has('referrenCode');
}

function generateItemKey(item) {
  const props = item.properties || {};
  const propsString = Object.keys(props)
    .sort()
    .map(key => `${key}:${props[key]}`)
    .join('|');

  return `${item.variant_id || item.productVariantId}|${propsString}`;
}

async function restoreMissingCartItems(savedCart) {
  const currentCart = await fetch('/cart.js').then(res => res.json()).then(data => data.items);

  const currentKeys = new Set(currentCart.map(generateItemKey));

  const missingItems = savedCart.filter(item => {
    const key = generateItemKey(item);
    return !currentKeys.has(key);
  });

  if (missingItems.length > 0) {
    console.log(`Restored ${missingItems.length} missing items to cart.`);
    
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: missingItems.map(({ productVariantId, quantity, sellingPlanId }) => {
          const item = {
            id: productVariantId,
            quantity: quantity,
          };

          if (sellingPlanId) {
            item.selling_plan = sellingPlanId;
          }

          return item;
        })
      })
    });
    
    setTimeout(() => {
      saveCartToServer(); // Call your existing function
    }, 1000);
  } else {
    console.log('No missing items. Cart is already in sync.');
  }
}

async function saveCartToServer() {
  try {
    if (!window.Shopify || !Shopify.customer) return; // Only save if customer is logged in
    const cart = await fetch('/cart.js').then(res => res.json());

    const payload = cart.items.map(item => ({
        productVariantId: `${item.variant_id}`,
        quantity: item.quantity,
        properties: item.properties || {},
        sellingPlanId: item.selling_plan_allocation?.selling_plan?.id || null,
    }));

    const data = {
      shoppingCart: payload,
    };

    try {
      await updateShoppingCart(data);
      console.log('Update global cart success');
    } catch (err) {
      console.log(`Update global cart fail. ${err}`);
    }

    console.log('Cart saved to server');
  } catch (err) {
    console.error('Error saving cart:', err);
  }
}

async function restoreCartFromServer() {
  if (!window.Shopify?.customer) return;

  try {
    const profile = await getShoppingCart();
    const savedCart = profile?.shoppingCart?.shoppingCart || [];

    if (!savedCart.length) return; 
    restoreMissingCartItems(savedCart);
  } catch (err) {
    console.error('Failed to restore global cart:', err);
  }
}

function bindLogoutLink() {
  const link = document.getElementById('logout-link');
  if(link) {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      localStorage.removeItem('userType');
      localStorage.removeItem('jwtToken');
      fetch('/account/logout', {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
      }).then(() => {
        window.location.href = '/pages/oneclick';
      });
    });
  }
}

function detectIp() {
  const userType = localStorage.getItem('userType');
  if(userType == 'Doctor') {
    document.body.classList.add('visitor-other');
    document.body.classList.add('is-doctor');
  }
  else {
    fetch('https://api.country.is/')
    .then(res => res.json())
    .then(data => {
      if (data.country === "MY") {
        document.body.classList.add('visitor-my');
      } else {
        document.body.classList.add('visitor-other');
      }
    });
  }
}

window.addEventListener('DOMContentLoaded', () => {
  bindLogoutLink();
  detectIp();

  if (!hasAffiliateCartParam()) {
    restoreCartFromServer();
  }
  if (window.Shopify && Shopify.customer) {
    getProfile();
  }
});


window.saveCartToServer = saveCartToServer;
